import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";

export const SearchItemTitle = ({ tooltip, children, required = false }) => {
  return (
    <Popover>
      <div className="flex items-center gap-2">
        <h4 className="font-bold text-lg">
          {children}
          {required && (
            <span className="text-red-500 superscript text-sm pl-1">*</span>
          )}
        </h4>
        {tooltip && (
          <PopoverTrigger>
            <InfoIcon color="blue.200" />
          </PopoverTrigger>
        )}
      </div>
      {tooltip && (
        <PopoverContent>
          <PopoverArrow />
          <PopoverHeader>{tooltip}</PopoverHeader>
        </PopoverContent>
      )}
    </Popover>
  );
};
